import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { fetchPartners, deletePartner } from 'actions/Partners'
import MitraView from 'components/pages/mitra'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchPartners: bindActionCreators(fetchPartners, dispatch),
  deletePartner: bindActionCreators(deletePartner, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {}),
  withHandlers({
    getList: props => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchPartners(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading, getList } = props
      setIsLoading(true)

      try {
        const res = await props.deletePartner(id)
        message.success(res)
        getList()
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Mitra',
        activePage: 'mitra',
        activeSubPage: 'mitra',
      })

      this.props.getList()
    },
  }),
)(MitraView)
